export default "__VITE_ASSET__Dn3Jm$jt__"